import { CONSTANTS } from "@data"

const { FLAGS } = CONSTANTS

/* eslint-disable */
/**
 * @param {String} selector : The selector to query
 * @param {Element} context : The element to search within.
 */
export const q = function q(selector, context) {
  return (context || document).querySelector(selector)
}

/**
 * @param {String} selector : The selector to query
 * @param {Element} context : The element to search within.
 */
export const qAll = function qAll(selector, context) {
  return (context || document).querySelectorAll(selector)
}

/**
 * @param {String} timestampString : i.e. 2018-10-06T00:00-04:00
 */
export const getYearFromTimestamp = function getYearFromTimestamp(timestampString) {
  return timestampString.split("-")[0]
}

export const stripHTML = html => {
  if (typeof document === "undefined") {
    return html
  }

  let tmp = document.createElement("DIV")
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ""
}

/*
 Test for IE11
 */
const windowGlobal = typeof window !== "undefined" && window

export const isIE = function isIE() {
  return (!!windowGlobal.MSInputMethodContext && !!document.documentMode) || !!windowGlobal.msCrypto
}

export const isSimplifiedLayout = function isSimplifiedLayout() {
  return isIPad() || isEdge()
}

export const isIPad = function isIPad() {
  return (
    !!windowGlobal &&
    !!windowGlobal.navigator &&
    windowGlobal.navigator.userAgent.indexOf("iPad") > -1
  )
}

export const isEdge = function isEdge() {
  return (
    !!windowGlobal &&
    !!windowGlobal.navigator &&
    windowGlobal.navigator.userAgent.indexOf("Edge") > -1
  )
}

/**
 * Used to remove units from SASS values
 * @param {string} unitValue - get a number back from a value with a unit
 */
export const useSassUnitValues = unitValue => {
  return parseInt(unitValue, 10)
}

/**
 * isMobile: checks whether the viewport sizes is <= than MOBILE_BREAKPOINT (i.e. 1024)
 * @type {number}
 */
const MOBILE_BREAKPOINT = useSassUnitValues(CONSTANTS.BREAKPOINTS.MOBILE_ANY)

export const isMobile = function isMobile() {
  return windowGlobal.innerWidth <= MOBILE_BREAKPOINT || isIE() || isSimplifiedLayout()
}

//Had to generate this function to evaluate the breakpoint specifically for IE....
export const isMobileIE = function isMobile() {
  return (
    windowGlobal.innerWidth <= MOBILE_BREAKPOINT ||
    windowGlobal.navigator.userAgent.indexOf("iPad") > -1
  )
}

const isString = value => {
  return Object.prototype.toString.call(value) === "[object String]"
}

export const css = (...args) => {
  let stylesList = []

  args
    .filter(style => !!style) // remove any falsey values from our styles array and join our style classes.
    .forEach(style => {
      if (Array.isArray(style)) {
        stylesList = stylesList.concat(css(...style)) // Use recursion to handle nested array of styles.
      } else if (isString(style)) {
        stylesList.push(style) // Only add strings to our results
      }
    })

  return stylesList.join(" ")
}

export const setCookie = function setCookie(cname, cvalue, exdays) {
  let d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  let expires = "expires=" + d.toUTCString()
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
}

export const getCookie = function getCookie(cname) {
  if (typeof document === "undefined") {
    return ""
  }
  let name = cname + "="
  let decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(";")
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === " ") {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ""
}

export const mapRange = function(value, in_min, in_max, out_min, out_max) {
  return ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
}

export const formatTwoDigits = index => {
  return index < 10 ? "0" + index : index
}

export const IOSupported = () => {
  if (typeof window !== `undefined` && window.IntersectionObserver) {
    return true
  } else {
    return false
  }
}

export const arrayDiffs = (array1, array2) => {
  const comparer = arr => {
    return current => {
      return (
        arr.filter(currArr => {
          return currArr.id === current.id
        }).length === 0
      )
    }
  }
  const onlyInArray1 = array1.filter(comparer(array2))
  const onlyInArray2 = array2.filter(comparer(array1))

  return [...onlyInArray1, ...onlyInArray2]
}

export const getMousePosition = (e, scrollingContainer) => {
  let x
  let y
  scrollingContainer = document.scrollingElement || scrollingContainer || document.documentElement
  if (e) {
    if (e.touches && e.touches[0]) {
      x = e.touches[0].clientX
      y = e.touches[0].clientY
    } else {
      //FireFox
      x = e.pageX
      y = e.pageY - scrollingContainer.scrollTop
    }
  } else {
    //IE
    x = window.event.x + document.body.scrollLeft - 2
    y = window.event.y + document.body.scrollTop - 2
  }
  return { x, y }
}

/**
 * Format for gatsby links
 * @param {string} p - string to make a url
 * @returns {string} - formatted for links
 * @todo RESOLVE CIRCULAR DEPENDENCY WITH DATA/URLS.JS
 * @see copy of this function in the file data/urls.js
 */
export const formatPathname = p => {
  return p.slice(-1) !== "/" ? `${p}/` : p
}

export const hashCode = s => {
  var h = 0,
    l = s.length,
    i = 0
  if (l > 0) while (i < l) h = ((h << 5) - h + s.charCodeAt(i++)) | 0
  return h
}

/* eslint-enable */

/**
 * @param {String} date : The date to be converted
 * @returns {String} The date formatted
 */
export const formatDate = date => {
  const options = { year: "numeric", month: "long", day: "numeric" }
  return new Date(`${date}T00:00:00`).toLocaleDateString("en-US", options)
}

/**
 * Format a string suitable to be a url Slug
 * @param {string} str - input string
 * @returns converted string
 * @example formatSlug("our url") // "our-url"
 */
export const formatSlug = str => {
  const slug = (str || "")
    .toString()
    .toLowerCase()
    .trim()
    .replace(" ", "-")
  return slug
}

/**
 * Take a slug and convert to a legible phrase
 * @param {string} slug - slug string to revert
 * @return converted string
 * @example revertSlug("string_like-this") // "string like this"
 * NOTE that to do something with the string case requires CSS
 */
export const revertSlug = slug => {
  const str = slug
    .replace(/-/g, " ")
    .replace(/_/g, " ")
    .replace(/\//g, " ")
    .replace(/\s+/g, " ")
  return str
}

/**
 * Primarily used in analytics, to take something like a link and convert it to a "CONSTANT" type key.
 * @param  {string} val - string to manipulate
 * @return {string}     - string to use
 * @example '/exo-works' // EXOWORKS
 */
export const makeKeySafe = val => {
  const str = revertSlug(val)
    .replace(/\s+/g, "")
    .replace(/\/+/g, "")
    .replace(/=/g, "")
    .replace("undefined", "")
    .toUpperCase()
  return str
}

/**
 * Combine a series of string arguments and return a dot delimited list
 * @param  {...string} argList - arguments list
 * @return {string}         - returns a concatentated string list without undefined values
 */
export const combineMakeDotList = (...argList) => {
  return argList
    .filter(x => !!x)
    .map(i => makeKeySafe(i))
    .join(".")
}

/**
 * Return a phrase with the first letter of each word capitalized.
 * Note this is a dumb transformation and things like "a" will be capitalized
 * @param {string} words - a string, usually something like "words with friends"
 */
export const initCaps = words => {
  const phrase = words.split(" ")
  return phrase
    .map(i => {
      return i.charAt(0).toUpperCase() + i.slice(1)
    })
    .join(" ")
}

/**
 * Maintain log statements for future debugging or logging based on a flag.
 * Why this way? The usage of console.log.bind(console) maintains line numbers, etc.
 * @param {bool} enable - either enable or disable based on this flag
 * @example
 *  import { logTool } from 'utils';
 *  const logger = logTool();
 *  logger('log', 'like', 'normal'); // output
 *  - or -
 *  const logOff = logTool(false);
 *  logOff('nothing', 'comes', 'out'); // nothing is output
 */
export const logTool = enable => {
  if (enable === true || (enable !== false && CONSTANTS.LOG)) {
    // eslint-disable-next-line no-console
    return console.log.bind(console)
  }
  return () => {}
}

export const randomInt = (minNum, maxNum) => {
  // eslint-disable-next-line no-param-reassign
  const num = Math.floor(Math.random() * (maxNum - minNum + 1) + minNum)
  return num
}

export class SeededRandom {
  constructor(seed) {
    this.seed = seed
  }

  random = (min, max) => {
    // eslint-disable-next-line no-param-reassign
    max = max || 1
    // eslint-disable-next-line no-param-reassign
    min = min || 0

    this.seed = (this.seed * 9301 + 49297) % 233280
    const rnd = this.seed / 233280

    return min + rnd * (max - min)
  }
}

export const reverseNumber = num => {
  // Remember if it's negative
  const isNegative = num < 0
  // Get the digits and decimal just for the absolute part
  const chars = (isNegative ? -num : num).toString().split("")
  // Reverse them
  chars.reverse()
  // Put it back together and convert back to a number
  const newNum = Number(chars.join(""))
  // Return the result, converting back to negative if appropriate
  return isNegative ? -newNum : newNum
}

export const toLowerCaseIfExists = str => {
  return str !== null && str !== undefined ? str.toLowerCase() : null
}

/**
 * Bind a document event listener
 * @param {string} evt - event string name
 * @param {function} cb - callback function
 * @param {boolean} addRemove - if true, we add the listener, if false, we remove
 */
export const listenDocEvent = (evt, cb, addRemove = true) => {
  if (addRemove) {
    // console.trace("listenDocEvent", cb, addRemove)
    window.addEventListener(evt, cb)
  } else {
    // console.trace("listenDocEvent", cb, addRemove)
    window.removeEventListener(evt, cb)
  }
}

/**
 * For get method
 * @param path
 * @returns {*|Array}
 * @private
 */
function stringToPath(path) {
  const containsBracketNotation = /\[[0-9]+\]/g
  if (path.match(containsBracketNotation)) {
    // eslint-disable-next-line no-param-reassign
    path = path.replace(containsBracketNotation, s => `.${s.substring(1, s.length - 1)}`)
  }
  return path.split(".")
}

/**
 * Safely get a path
 * This replaces _.get() from Lodash
 * @function
 * @requires {function} _stringToPath
 * @param {object} source
 * @param {string} path with dots, usually
 * @returns {*}
 * @private
 */
export function get(source, path) {
  return stringToPath(path).reduce((nestedObject, key) => {
    // eslint-disable-next-line no-void
    return nestedObject && key in nestedObject ? nestedObject[key] : void 0
  }, source)
}

/**
 * Is this feature enabled or not?
 * @param {string} flag - feature flag from constants FLAGS.
 * Note the flag may contain dots, as we split and check recursively
 * @returns {boolean}
 * @example
 *    featureFlag("link.technology") // true or false
 * @example
 *    featureFlag("visionOurPeople") // true or false
 */
export const featureFlag = flag => {
  return !!get(FLAGS, flag)
}

/**
 * @name debounce
 * @desc Debounces a function so its called only after it stops being called; be sure to use event.persist() for accessing event properties in an asynchronous way in react
 * @param {Function} func function to be debounced
 * @param {*} context context to run the function in
 * @param {Number} wait waiting time in milliseconds for debouncing effect
 * @param {Boolean} immediate trigger the function on the leading edge, instead of the trailing.
 * @return {Function}
 * @memberof utils/main
 * @example
 * const myEfficientFn = debounce(function() {
 *  // All the taxing stuff you do
 * }, 250);
 * window.addEventListener('resize', myEfficientFn);
 */
export const debounce = (func, context, wait, immediate) => {
  let timeout
  return (...rest) => {
    const args = rest
    const later = () => {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

/**
 * Load a script via a script tag
 * @param {string} src - url to load the script for
 */
export const createScriptTag = src => {
  const tag = window.document.createElement("script")
  tag.src = src
  const firstScriptTag = window.document.getElementsByTagName("script")[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}

/**
 *  Easing function
 * @param {Number} t - Time passed since the beginning of the animation.
 * @param {Number} b - The starting point of the animation. Usually static.
 * @param {Number} c - The amount of change needed to go from starting point to end point. Usually static.
 * @param {Number} d - Duration. Usually static.
 * @returns {Number}
 */
export const easeInOutCubic = (tp, b, c, d) => {
  let t = tp / (d / 2)
  if (t < 1) return (c / 2) * t * t * t + b
  t -= 2
  return (c / 2) * (t * t * t + 2) + b
}

export const easeOutQuart = (tp, b, c, d) => {
  let t = tp / d
  t--
  return -c * (t * t * t * t - 1) + b
}
